<div
  scId="SC1037"
  class="relative inline-block"
  (click)="goToPDP(hardgoodData)"
  (keyup.enter)="goToPDP(hardgoodData)"
>
  <!-- Highest Rated Badge -->
  <div *ngIf="bannerText" class="callout-icon xs-m-t-xs">
    <p class="xsmall">
      {{ bannerText }}
    </p>
  </div>
  <!-- Deal Badge -->
  <div
    *ngIf="dealText || hardgoodData?.hasDeal; else elseBlock"
    class="badge-magenta in-left m-r-xs"
  >
    <p class="legal">
      {{ dealText || contentData?.deal }}
    </p>
  </div>
  <!-- Sale Badge -->
  <ng-template #elseBlock>
    <div *ngIf="onSale" class="badge-magenta in-left m-r-xs">
      <p class="legal">
        {{ contentData?.sale }}
      </p>
    </div>
  </ng-template>

  <!-- Image -->
  <a
    href="javascript:void(0)"
    attr.aria-label="{{ hardgoodData?.familyName }}"
    id="{{ hardgoodData?.offerId }}"
  >
    <img
      id="device-image-{{ hardgoodData?.offerId }}"
      alt="{{ hardgoodData?.familyName }}"
      class="img-fluid browse-image cursor-pointer"
      [src]="currentDeviceDetails?.imageUrl"
      (load)="toggleLoader(true)"
      (error)="toggleLoader(true)"
    />
  </a>
  <div *ngIf="isLoading" class="img-loader">
    <div class="img-spinner">
      <i class="fa fa-spinner fa-pulse spinner-icon"></i>
    </div>
  </div>
  <!-- Name -->
  <p class="lead m-t-md cursor-pointer" id="family-name">
    {{ hardgoodData?.familyName }}
  </p>
</div>
<!-- Reviews -->
<ng-container *ngIf="!hardgoodData?.isEpin && currentDeviceDetails?.averageOverallRating > 0">
  <p class="xsmall m-t-md inline-block">
    <tmo-star-rating
      [rating]="currentDeviceDetails?.averageOverallRating"
      [showMiniStar]="true"
      [center]="true"
    ></tmo-star-rating>
  </p>
  <p class="m-t-xs inline-block align-text-bottom">
    <a
      id="review-link"
      class="xsmall"
      *ngIf="hardgoodData?.isReviewPresent"
      href="javascript:void(0)"
      id="review-text"
      attr.aria-label="{{ reviewsText }}"
      (click)="goToPDP(hardgoodData, true)"
    >
      {{ reviewsText }}
    </a>
  </p>
  <p class="m-t-xs">
    <!-- <a id="no-review-link" class="xsmall" *ngIf="!hardgoodData?.isReviewPresent && isWebChannel" id="no-review-text" href="javascript:void(0)" attr.aria-label="{{contentData?.noReviewsText}}" (click)="goToPDP(hardgoodData?.offerId, true)"> -->
    <a
      id="no-review-link"
      class="xsmall"
      *ngIf="!hardgoodData?.isReviewPresent"
      id="no-review-text"
      href="javascript:void(0)"
      attr.aria-label="{{ contentData?.noReviewsText }}"
      (click)="goToPDP(hardgoodData?.offerId, true)"
    >
      {{ contentData?.noReviewsText }}
    </a>
  </p>
</ng-container>

<!-- Color Picker -->
<div
  class="row justify-content-center m-t-sm"
  *ngIf="!hardgoodData?.isEpin && !hardgoodData?.isSimCard"
>
  <span class="color-radio small" *ngFor="let colors of hardgoodData?.itemDetails; let i = index">
    <input
      type="radio"
      attr.aria-label="{{ colors?.colorName }}{{ contentData?.option }}"
      name="'radio'+{{ hardgoodData?.offerId }}"
      id="{{ colors?.id }}"
      (click)="selectColor(colors?.id)"
      [checked]="currentDeviceDetails?.colorSwatchId === colors?.id"
    />
    <span class="img-color">
      <img
        id="sku-image"
        [src]="colors?.colorSwatchURL"
        class="bg-black"
        alt="{{ colors?.colorName }}"
      />
    </span>
  </span>
</div>

<!-- Promotions -->
<div class="row m-t-sm" *ngIf="hardgoodData?.hasDeal && currentDeviceDetails?.promotionDescription">
  <div class="col-12">
    <p class="xsmall m-t-sm" id="promotion-description">
      {{ currentDeviceDetails?.promotionDescription | truncate: [hardgoodConstants.TRUNCATE] }}
    </p>
  </div>
</div>
<!-- Strike through Price -->
<p
  class="xsmall m-t-sm strikethrough"
  id="list-price-with-service"
  *ngIf="onSale && !isP10MCustomer"
>
  {{ strikeThroughPrice }}
</p>

<!-- Price -->
<tmo-devices-pricing-panel
  [deviceAmount]="currentDeviceDetails?.payNowPrice"
  [id]="hardgoodData?.familyName"
  [isEpin]="hardgoodData?.isEpin"
  [pricingOptions]="pricingOptions"
  [isBrowseAccessory]="true"
  [id]="hardgoodData?.offerId"
>
</tmo-devices-pricing-panel>
<div class="row" *ngIf="hardgoodData?.isEpin">
  <div class="col-12">
    <p class="m-t-xs xsmall">{{ contentData?.dueToday }}</p>
  </div>
</div>

<!-- Plus Taxes And without Qualifying Plan message -->
<ng-container *ngIf="!hardgoodData?.isAccessory">
  <ng-container *ngIf="!(promoDisclaimer && replacePricingDisclaimer)">
    <div class="xsmall" [innerHtml]="hardGoodCotentMessage"></div>
  </ng-container>
  <p *ngIf="promoDisclaimer" class="xsmall">{{ promoDisclaimer }}</p>
</ng-container>

<!-- Compare Button -->
<div
  class="row m-t-lg inline-block"
  *ngIf="!hardgoodData?.isAccessory && !hardgoodData?.isEpin && !isP10MCustomer"
>
  <div class="col-12">
    <label class="form-label">
      <span class="tmo-checkbox">
        <input
          type="checkbox"
          id="compare-checkbox"
          attr.aria-label="{{ contentData?.compare }}"
          [disabled]="disableCheckbox && !isCheckBoxSelected"
          (click)="onCheckboxClicked()"
          [checked]="isCheckBoxSelected"
        />
        <span class="checkbox compare">
          <i id="compare-checkbox-image" class="fa fa-check"></i>
        </span>
      </span>
      <p class="content">
        <a
          id="compare-link"
          href="javascript:void(0)"
          attr.aria-label="{{ contentData?.compare }}"
          [class.disabled]="disableCompareLink"
          (click)="navigateToCompare()"
        >
          {{ contentData?.compare }}
        </a>
      </p>
    </label>
  </div>
</div>
<!-- Disclaimer -->
<div class="row m-t-lg d-md-none">
  <div class="col-12">
    <p class="legal">
      {{ contentData?.disclaimer }}
    </p>
  </div>
</div>
<!-- Divider -->
<div class="row m-t-xl d-md-none">
  <div class="col-12">
    <hr class="divider" />
  </div>
</div>
